
export function playNotificationSound(data, selectedKds, kitchenDisplayScreens) {
    let allCategoryIds = [];
    if (selectedKds != null) {
      const index = kitchenDisplayScreens?.findIndex(obj => obj.name === selectedKds);
      if (index !== -1) {
        allCategoryIds = kitchenDisplayScreens[index]?.categories.map(category => category._id);
      }
    }
    const hasCommonElement = data.categoriesToPrepare.some(item => allCategoryIds.includes(item));
    return hasCommonElement;
  }